import axios from 'axios';
import { getCookie, setCookie } from 'lib/cookies';

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  async (config) => {
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  });

axiosInstance.interceptors.response.use(
  async (response) => {
    const configs = {
      headers: {
        'Authorization': `Bearer ${getCookie('access')}`,
        'Set-Cookie': getCookie('refresh'),
      },
    };
    const { data } = await axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_USER}/silent-refresh`, configs);
    const { accessToken, refreshToken } = data;

    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    setCookie('access', accessToken, { 'max-age': 60 * 30 });
    setCookie('refresh', refreshToken, { 'max-age': 60 * 60 });

    return response;
  },
  async (error) => {
    // const { config, response: { status } } = error;
    // if (status === 401) {
    //   if (error.response.data.message === 'jwt expired') {
    //     const originalRequest = config;

    //     const refreshToken = { headers: { 'Set-Cookie': getCookie('refresh') } };
    //     const { data } = await axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_USER}/silent-refresh`, refreshToken);
    //     const { accessToken: newAccessToken, refreshToken: newRefreshToken } = data;

    //     axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
    //     setCookie('refresh', newRefreshToken, { 'max-age': 1000 * 60 * 60 });

    //     originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
    //     return axios(originalRequest);
    //   }
    // }

    const { response: { data, status } } = error;
    if (status === 401 && data.isAuth === false) {
      if (data.message === '토큰이 없습니다.') {
        delete axios.defaults.headers.common['Authorization'];
        window.location.replace('/auth/login');
        window.location.reload();
      }
    }
    return Promise.reject(error);
  });

export default axiosInstance;
